import { Box, IconButton } from '@mui/material';
import MuiModal from '@mui/material/Modal';
import { X } from 'lucide-react';
import { ReactNode } from 'react';

export default function Modal({
    children,
    open,
    onClose,
    showCloseButton = true,
}: {
    children: ReactNode | ReactNode[];
    open: boolean;
    onClose?: () => void;
    showCloseButton?: boolean;
}) {
    return (
        <MuiModal open={open} onClose={onClose} disableAutoFocus>
            <Box
                sx={{
                    position: 'absolute' as const,
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                }}
            >
                <Box position="relative">
                    {showCloseButton && (
                        <IconButton
                            data-testid="closeModalButton"
                            onClick={onClose}
                            aria-label="Close"
                            sx={{
                                position: 'absolute',
                                top: -24,
                                right: -24,
                            }}
                        >
                            <X size={21} />
                        </IconButton>
                    )}
                    {children}
                </Box>
            </Box>
        </MuiModal>
    );
}
